<template>
  <div class="container">
    <div class="left">
      <div class="contentSelect">
        <el-select
          v-model="contentSelect"
          placeholder="请选择需要修改的内容类型"
          @change="_getContentType"
        >
          <el-option
            v-for="item in contentType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div>
        <!--卡片选择新闻-->
        <el-card class="box-card" style="margin-top: 50px">
          <div slot="header" class="clearfix">
            <span>卡片名称</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="addNew"
              >新增新闻</el-button
            >
          </div>
          <div class="text item">
            <ul
              v-infinite-scroll="load"
              infinite-scroll-disabled="disabled"
              infinite-scroll-delay="200"
              class="infinite-list"
              style="overflow: auto; max-height: 200px"
            >
              <li
                v-for="i in newsList[0]"
                :key="i.name"
                class="infinite-list-item"
                @click="choose(i)"
              >
                {{ i.title }}
              </li>
            </ul>
            <p v-if="loading">加载中...</p>
            <p v-if="noMore">没有更多了</p>
          </div>
        </el-card>
      </div>
    </div>

    <!--右侧表单-->
    <div class="right">
      <div v-if="Object.keys(form).length > 0" class="form">
        <form-tpl
          :form="form"
          class="form"
          @refreshInsert="refreshInsert"
          @refresh="refresh"
        />
      </div>
    </div>
  </div>
</template>

<script>
import formTpl from '@/components/Form/form-tpl'
import HomeApi from '../../network/home'
import { content_type } from '../../common/enum/imgEnum'

export default {
  name: 'EditNews',
  components: {
    formTpl
  },
  data() {
    return {
      contentType: [
        { value: 10, label: '公司新闻' },
        { value: 11, label: '行业新闻' }
      ],
      contentSelect: content_type.companyNews,
      pageNum: 1,
      pageSize: 5,
      newsList: [],
      form: {},
      loading: false,
      code: ''
    }
  },
  created() {
    this.load()
  },
  methods: {
    // 获取展示内容
    load() {
      this.loading = true
      setTimeout(async () => {
        await this.handlerNews(this.contentSelect)
        this.pageNum += 1
        this.loading = false
      }, 500)
    },

    _getContentType() {
      this.pageNum = 1
      this.newsList = []
      this.load()
    },

    disabled() {
      return this.loading || this.noMore
    },

    noMore() {
      return this.code === '501'
    },

    async refresh(type) {
      this._getContentType()
      await this.handlerNews(type)
    },

    async refreshInsert(type) {
      this.form = {}
      this._getContentType()
      await this.handlerNews(type)
    },

    // 处理所有新闻
    async handlerNews(contentType) {
      const { data, code } = await HomeApi.getNewsPage(
        this.pageNum,
        this.pageSize,
        contentType
      )
      this.code = code
      const list = JSON.parse(JSON.stringify(data.list))
      list.forEach((k) => {
        k.contentType = k.content_type
        k.createTime = k.create_time
        k.programType = k.program_type
      })
      this.newsList.push(list)
    },

    // 选择新闻
    choose(form) {
      this.form = form
    },

    // 新增新闻
    addNew() {
      this.form = {}
      this.form.isInsert = true
      this.form.programType = 2
    }
  }
}
</script>

<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
}

.infinite-list-item {
  margin: 20px;
  cursor: pointer;
  color: #409eff;
}

.container {
  display: flex;
}
</style>
